import React from 'react';
import { useTheme } from '../App';
import ActionCard from './ActionCard';
interface LeversSectionProps {
  kpiName: string;
}
const LeversSection: React.FC<LeversSectionProps> = ({
  kpiName
}) => {
  const {
    isDarkMode
  } = useTheme();
  // Sample levers data for different KPIs
  const leversData: Record<string, any[]> = {
    'Total Sales': [{
      title: 'Run flash sale on slow-moving premium flower',
      description: 'Why now: 6 premium strains aging > 20 days + competitor promotion nearby',
      confidenceScore: 82,
      valueType: 'GMV Uplift',
      valueAmount: 3200,
      timeSaved: 40,
      size: 'M' as const,
      urgency: 'High' as const
    }, {
      title: 'Implement bundle pricing on concentrate + accessories',
      description: 'Why now: Cross-category purchase data shows opportunity',
      confidenceScore: 78,
      valueType: 'GMV Uplift',
      valueAmount: 1800,
      timeSaved: 30,
      size: 'S' as const,
      urgency: 'Medium' as const
    }],
    'Avg Basket': [{
      title: 'Optimize register upsell recommendations',
      description: 'Why now: Current attach rate below benchmark by 15%',
      confidenceScore: 85,
      valueType: 'GMV Uplift',
      valueAmount: 2100,
      timeSaved: 25,
      size: 'S' as const
    }],
    Transactions: [{
      title: 'Reactivate dormant customers with targeted promo',
      description: "Why now: 250+ customers haven't visited in 45+ days",
      confidenceScore: 79,
      valueType: 'GMV Uplift',
      valueAmount: 4500,
      timeSaved: 60,
      size: 'L' as const
    }, {
      title: 'Optimize store hours based on traffic patterns',
      description: 'Why now: Significant untapped demand in early morning hours',
      confidenceScore: 88,
      valueType: 'GMV Uplift',
      valueAmount: 3800,
      timeSaved: 45,
      size: 'M' as const
    }],
    'New Customers': [{
      title: 'Implement first-time customer special bundle',
      description: 'Why now: Current new customer conversion rate below benchmark',
      confidenceScore: 84,
      valueType: 'GMV Uplift',
      valueAmount: 2800,
      timeSaved: 35,
      size: 'M' as const
    }],
    Margin: [{
      title: 'Optimize pricing on high-velocity SKUs',
      description: 'Why now: 15 top sellers priced below market average',
      confidenceScore: 91,
      valueType: 'Margin Improvement',
      valueAmount: 5200,
      timeSaved: 50,
      size: 'M' as const
    }, {
      title: 'Adjust purchasing mix based on margin analysis',
      description: 'Why now: Inventory mix skewed toward lower-margin categories',
      confidenceScore: 86,
      valueType: 'Margin Improvement',
      valueAmount: 6800,
      timeSaved: 70,
      size: 'L' as const
    }],
    'Inventory Value': [{
      title: 'Clear slow movers: 12 SKUs aging > 45 days',
      description: 'Why now: Aging inventory tying up significant cash',
      confidenceScore: 89,
      valueType: 'Cash Unlocked',
      valueAmount: 4800,
      timeSaved: 40,
      size: 'M' as const
    }, {
      title: 'Optimize reorder points based on velocity',
      description: 'Why now: Several categories overstocked by 30%+',
      confidenceScore: 83,
      valueType: 'Cash Unlocked',
      valueAmount: 7500,
      timeSaved: 55,
      size: 'L' as const
    }]
  };
  const levers = leversData[kpiName] || [];
  return <div className={`mt-6 p-4 rounded-lg ${isDarkMode ? 'bg-[#0d1117]' : 'bg-white'}`} data-id="element-278">
      <h3 className="text-lg font-bold mb-3" data-id="element-279">Levers for {kpiName}</h3>
      {levers.length > 0 ? levers.map((lever, index) => <ActionCard key={index} {...lever} data-id="element-280" />) : <p className="text-sm opacity-80" data-id="element-281">
          No improvement levers needed for this metric right now.
        </p>}
    </div>;
};
export default LeversSection;